module.exports = __webpack_public_path__ + "static/img/room_mb.598eccd6.png";